export const PERMISSION_CODES = {
  KNOWLEDGE_READ: 'knowledge.read',
  KNOWLEDGE_CREATE: 'knowledge.create',
  KNOWLEDGE_UPDATE: 'knowledge.update',
  KNOWLEDGE_DELETE: 'knowledge.delete',
  KNOWLEDGE_PUBLISH: 'knowledge.publish',
  WORKFLOW_READ: 'workflow.read',
  WORKFLOW_CREATE: 'workflow.create',
  WORKFLOW_UPDATE: 'workflow.update',
  WORKFLOW_DELETE: 'workflow.delete',
  CAPABILITY_READ: 'capability.read',
  CAPABILITY_MANAGE: 'capability.manage',
  ORGANIZATION_READ: 'organization.read',
  ORGANIZATION_MANAGE: 'organization.manage',
  ANALYTICS_READ: 'analytics.read',
  ANALYTICS_MANAGE: 'analytics.manage',
  PROMPT_READ: 'prompt.read',
  PROMPT_MANAGE: 'prompt.manage',
  ADMIN_ACCESS: 'admin.access',
  ADMIN_USERS: 'admin.users',
  ADMIN_SETTINGS: 'admin.settings',
} as const;

export type PermissionCode = (typeof PERMISSION_CODES)[keyof typeof PERMISSION_CODES];

export const ROLE_SLUGS = {
  VISITOR: 'visitor',
  USER: 'user',
  CONTRIBUTOR: 'contributor',
  REVIEWER: 'reviewer',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
} as const;

export type RoleSlug = (typeof ROLE_SLUGS)[keyof typeof ROLE_SLUGS];

export interface Permission {
  id: string;
  code: string;
  name: string;
  description: string | null;
  resource: string;
  action: string;
}

export interface Role {
  id: string;
  name: string;
  slug: RoleSlug;
  description: string | null;
  is_system: boolean;
  hierarchy_level: number;
}

export interface UserRole {
  id: string;
  user_id: string;
  role_id: string;
  organization_id: string | null;
  granted_at: string;
  role: Role;
}

export interface UserPermissions {
  roles: UserRole[];
  permissions: string[];
  isLoading: boolean;
}
